import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-legislatie',
  templateUrl: './legislatie.component.html',
  styleUrls: ['./legislatie.component.scss']
})
export class LegislatieComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
